import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import {PageTitleBar} from '../../layout';

import styles from './email-templates-page-header.module.css';

type Props = {
    title: string;
    subTitle: string;
    currentPath: string;
};

export function EmailTemplatesPageHeader(props: Props) {
    return (
        <div className={styles['email-templates-page-header']}>
            <PageTitleBar
                title={props.title}
                subheaderPrimaryText={props.subTitle}
                buttons={
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        variant='button-primary'
                        size='big'
                        to={`${props.currentPath}/new`}
                        replace={true}
                    >
                        + Add new template
                    </Link>
                }
            />
        </div>
    );
}
